export default __webpack_public_path__ + "static/media/app-icon.bfd686fe.png";